module.exports = __webpack_public_path__ + "static/mouse-right.b6dafea213325387ff421479a36a9844.svg";